module.exports = __webpack_public_path__ + "static/media/settings_user_icon.f1213083.svg";